import React, { Component } from "react";
import "../../styles/principals/footer.css";

class FooterSmall extends Component {

  render() {

 const claseFooter = this.props.footerDesplazado ? 'shifted' : '';

    return (
        <div className={`footer ${claseFooter}`}>
            <div className="footer-privacity">
                <ul className="privacity-list">
                    <li>
                        <a href="/legalnotice">Aviso legal</a>
                    </li>
                    <li>
                        <a href="/privacypolicy">Política de privacidad</a>
                    </li>
                    <li>
                        <a href="/accessibilitystatement">Declaración de accesibilidad</a>
                    </li>
                    <li className="last-item">
                        <a href="/cookiepolicy">Política de cookies</a>
                    </li>
                </ul>
            </div>
        </div>
      );
  }
}

export default FooterSmall;
